import React from "react";
import "./SponsorProfile.css";
const SlotModal = ({ show, onClose, slots = [], selectedSlot, setSelectedSlot }) => {

  if (!show) return null;
  return (
    <div className="slot-popup-overlay">
      <div className="slot-popup-modal enhanced-modal">
        <div className="modal-header-enhanced">
          <h4 className="fw-bold">Select Slot Position</h4>
          <button className="close-enhanced-btn" onClick={onClose}>✖</button>
        </div>
        <div className="legend-container">
          <span className="legend-item">
            <span className="legend-dot available-dot"></span> Available
          </span>
          <span className="legend-item">
            <span className="legend-dot booked-dot"></span> Booked
          </span>
        </div>

        <div className="slot-grid">
          {slots.map((slot) => (
            <div
              key={slot.slotNumber}
              className={`slot-card-enhanced
                ${slot.isSlotBooked ? "booked" : ""}
                ${selectedSlot === slot.slotNumber ? "active" : ""}`}
             onClick={() => {
      if (!slot.isSlotBooked) {
       setSelectedSlot(Number(slot.slotNumber));
    onClose();
       }
    }} >
  <div className="slot-number-enhanced">{slot.slotNumber}</div>
  <div className="slot-price-enhanced">₹{slot.price}/week</div>
  </div>
))}
 </div>
 </div>
 </div>
  );
 };

export default SlotModal;
